import React, { useEffect, useState } from "react";
import {
  _getBaseUrl,
  _getCSRFTokenValue,
  _getTileShape,
} from "../utils/helper";
import { Pagination } from "../atoms";
import StateView from "../utils/StateView";

const InspiratieViewList = () => {
  const [values, setValues] = useState({});
  const [posts, setPosts] = useState([]);
  const [favourites, setFavourites] = useState([]);
  const [hoveredId, setHoveredId] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingPosts, setIsLoadingPosts] = useState(false);

  // Fetch posts
  // useEffect(() => {
  //   const fetchNodes = async () => {
  //     try {
  //       const csrfToken = await _getCSRFTokenValue();
  //       const res = await fetch("/api/inspiratiepunten_searchandfilter", {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-CSRF-Token": csrfToken,
  //         },
  //         body: JSON.stringify({
  //           nodeStatus: [true],
  //           page: 1,
  //           postsPerPage: 99999,
  //         }),
  //       });

  //       const data = await res.json();
  //       setPosts(data.posts || []);
  //     } catch (err) {
  //       console.error("Fetch error:", err);
  //     }
  //   };

  //   fetchNodes();
  // }, []);

  // ------------------------

  useEffect(() => {
    const handleFiltersApplied = async (e) => {
      setIsLoadingPosts(true);

      try {
        const values = e.detail;
        const csrfToken = await _getCSRFTokenValue();

        const sendValues = {
          ...values,
          nodeStatus: [true],
          page: 1,
          postsPerPage: 10,
          publicView: true,
        };

        const res = await fetch("/api/inspiratiepunten_searchandfilter", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken,
          },
          body: JSON.stringify(sendValues),
        });

        const data = await res.json();
        setPosts(data.posts || []);
        setTotalPages(data.totalPages || 0);
        setValues(sendValues);

        document.dispatchEvent(
          new CustomEvent("fetchDataCompleted", {
            detail: "Fetch data completed",
          })
        );
      } catch (err) {
        console.error("Fetch error:", err);
      } finally {
        setIsLoadingPosts(false);
      }
    };

    // Restore filters from URL using clean query params
    const params = new URLSearchParams(window.location.search);
    const urlFilters = {
      keywords: params.getAll("keywords"),
      actueel_wijken: params.getAll("actueel_wijken"),
      transitieagenda: params.getAll("transitieagenda"),
    };

    const hasFilters =
      urlFilters.keywords.length > 0 ||
      urlFilters.actueel_wijken.length > 0 ||
      urlFilters.transitieagenda.length > 0;

    handleFiltersApplied({
      detail: hasFilters ? urlFilters : {}, // empty object = default fetch
    });

    // Always listen for filter changes
    document.addEventListener("filtersApplied", handleFiltersApplied);

    return () => {
      document.removeEventListener("filtersApplied", handleFiltersApplied);
    };
  }, []);


  // Load favourites from localStorage
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("inspiratie-favourites")) || [];
    setFavourites(stored.map(Number)); // force numeric ids
  }, []);





  const fetchPosts = async (newValues) => {
    setIsLoadingPosts(true);
    try {
      const csrfToken = await _getCSRFTokenValue();

      const res = await fetch("/api/inspiratiepunten_searchandfilter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify(newValues),
      });

      const data = await res.json();
      setPosts(data.posts || []);
      setTotalPages(data.totalPages || 0);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setIsLoadingPosts(false);
    }
  }





  const toggleFavourite = (nid) => {
    const numericId = Number(nid); // ensure number
    let updatedFavourites;

    if (favourites.includes(numericId)) {
      // remove
      updatedFavourites = favourites.filter((id) => id !== numericId);
    } else {
      // add
      updatedFavourites = [...favourites, numericId];
    }

    setFavourites(updatedFavourites);
    localStorage.setItem("inspiratie-favourites", JSON.stringify(updatedFavourites));

    const spanElm = document.querySelector(".fav-count");
    if (spanElm) {
      spanElm.textContent = 'Favorieten (' + updatedFavourites.length + ')';
    }
  };

  return (
    <div className="space-y-8">
      {isLoadingPosts && (
        <div className="h-48 sm:h-72 flex justify-center items-end">
          <img
            src={_getBaseUrl("src/assets/loading.gif", true)}
            alt="Loading"
            className="scale-50"
            style={{ transformOrigin: "center bottom" }}
          />
        </div>
      )}

      {posts.length === 0 && !isLoadingPosts ? (
        <div className="text-center mt-24 p-4 bg-white text-cirBlack border border-black rounded shadow-lg">
          Geen berichten beschikbaar
        </div>
      ) : (
        posts.map((post, index) => {
          const numericNid = Number(post.nid);
          const isFav = favourites.includes(numericNid);

          return (
            <div
              key={numericNid || index}
              className="card-inspiratiepunten-list"
            >
              <div className="rounded-[20px] px-8 py-6 bg-white">
                <div className="flex justify-between items-center gap-8 flex-wrap lg:flex-nowrap">
                  <div className="flex items-center gap-8 flex-wrap">
                    {/* Thumbnail */}
                    <div className="w-full sm:w-auto flex-shrink-0 flex sm:block items-center justify-start gap-6 sm:gap-0">
                      <div className="w-[85px] sm:w-[120px] aspect-square relative mx-auto flex-shrink-0">
                        <div className="absolute bottom-1 -right-1 z-0 sm:hidden">
                          {_getTileShape(post.image_shape, post.color, "85")}
                        </div>
                        <div className="absolute bottom-1 -right-1 z-0 hidden sm:block">
                          {_getTileShape(post.image_shape, post.color, "120")}
                        </div>
                        <img
                          src={post.imageUrl}
                          alt="Voorbeeld"
                          className={`list-thumbnail w-full h-full object-cover relative z-10 clip-path-${post.image_shape}`}
                        />
                      </div>
                      <h2 className="h4 font-sharpgrotesk mb-0 !text-xl sm:hidden flex-grow">{post.title}</h2>
                    </div>

                    {/* Title & Description */}
                    <div>
                      <h2 className="h4 font-sharpgrotesk mb-0 !text-xl hidden sm:block">{post.title}</h2>
                      {post.summary && (
                        <p className="card-inspiratiepunten--summary !text-base hidden sm:block">
                          {post.summary}
                        </p>
                      )}

                      {post.transitieagendaArray.length > 0 && (
                        <div className="flex flex-wrap gap-1">
                          {post.transitieagendaArray.map((ta) => (
                            <div
                              className="border rounded-full px-5 py-2 text-white w-fit text-sm whitespace-nowrap"
                              style={{ backgroundColor: ta.color }}
                            >
                              {ta.name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="shrink-0 flex justify-between gap-2 w-full lg:w-auto">
                    <button
                      onClick={() => toggleFavourite(numericNid)}
                      onMouseEnter={() => setHoveredId(numericNid)}
                      onMouseLeave={() => setHoveredId(null)}
                      aria-label="heart favourite icon"
                      className={`w-fit flex-shrink-0 flex-grow-0 button-favorieten text-base gap-2 align-bottom py-2.5 px-3.5 rounded-full border relative flex items-center justify-center cursor-pointer bg-white text-cirBlack ${isFav ? "active" : ""}`}
                    >
                      <img
                        src={
                          isFav
                            ? hoveredId === numericNid
                              ? _getBaseUrl("src/assets/inspiratiepunten/icon-heart.svg", true)
                              : _getBaseUrl("src/assets/inspiratiepunten/icon-heart-pink.svg", true)
                            : hoveredId === numericNid
                              ? _getBaseUrl("src/assets/inspiratiepunten/icon-heart-pink.svg", true)
                              : _getBaseUrl("src/assets/inspiratiepunten/icon-heart.svg", true)
                        }
                        alt=""
                      />
                    </button>

                    <a
                      href={`${post.permalink}`}
                      aria-label={`Lees meer ${post.title}`}
                      className="flex text-base gap-5 w-min-content py-2.5 px-6 rounded-full relative justify-center border-solid cursor-pointer align-bottom w-fit items-center bg-cirBlack border border-cirBlack hover:bg-white hover:border-black text-white hover:text-cirBlack nav-icon-after-white"
                    >
                      Lees meer
                    </a>
                  </div>
                </div>
                {/* Flex END */}
              </div>
            </div>
          );
        })
      )}

      <div>
        {(posts.length > 0 &&totalPages > 1) &&
          <div className="flex justify-center my-8">
            <Pagination
              totalPages={totalPages}
              page={values.page}
              setPage={(page) => {
                const newValues = { ...values, page: page };
                setValues(newValues);
                fetchPosts(newValues);
              }}
            />
          </div>
        }
      </div>

      <StateView
        title="posts"
        values={posts}
        className="bottom-4 right-4 h-auto"
        floating
        collapsed
      />
      <StateView
        title="values"
        values={values}
        className="top-4 bottom-[unset] right-4 h-auto"
        floating
        collapsed
      />
    </div>
  );

};

export default InspiratieViewList;
